import { memo } from "react";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { useTheme } from "@mui/material/styles";

import { HEADER } from "../config-layout";
import { useNavData } from "./config-navigation";
import HeaderShadow from "../common/header-shadow";
import { bgBlur } from "../../theme/css";
import Scrollbar from "../../components/layout-components/scrollbar";
import { NavSectionHorizontal } from "../../components/layout-components/nav-section";
import Searchbar from "../common/searchbar";
import { Stack } from "@mui/material";

// ----------------------------------------------------------------------

function NavHorizontal() {
  const theme = useTheme();

  const { user } = {
    user: {
      role: "admin",
    },
  };

  const navData = useNavData();

  return (
    <AppBar
      component="div"
      sx={{
        top: HEADER.H_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <Scrollbar
          sx={{
            "& .simplebar-content": {
              display: "flex",
            },
          }}
        >
          <Stack m={2} justifyContent="center" alignItems="flex-start">
            <Searchbar />
          </Stack>
          <NavSectionHorizontal
            data={navData}
            slotProps={{
              currentRole: user?.role,
            }}
            sx={{
              ...theme.mixins.toolbar,
            }}
          />
        </Scrollbar>
      </Toolbar>

      <HeaderShadow />
    </AppBar>
  );
}

export default memo(NavHorizontal);
